import React from "react";
import ErrorMessage from "components/error-message";
import { Input } from "components/haven-design/form/inputs";
import styles from "./batchActions.module.css";

export interface AddNoteStateValues {
  note: string;
}

interface Props {
  isLoading: boolean;
  onChange(data: AddNoteStateValues) : void;
  isShowing: boolean;
  errorMsg?: string;
}

const NoteForm: React.FC<Props> = (props) => {
  const [note, setNote] = React.useState<string>("");
  return (
    <form
      id="activityForm"
      onSubmit={(e) => e.preventDefault()}
      className={props.isShowing ? "" : styles.hideView}>

      <div className={styles.actionViewLabel}>Add a Note</div>
      <ErrorMessage errorMsg={props.errorMsg}/>

      <div>
        <Input
          name="reason"
          label="Reason"
          multiline
          onChange={({ target: { value } }) => {
            setNote(value);
            props.onChange({ note: value });
          }}
          value={note}
        />
      </div>
    </form>
  );
};
export default NoteForm;
